import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { userOptionActions } from '../state/user-option.actions';
import { userOptionSelectors } from '../state/user-option.reducer';

@Directive({
    selector: '[ndtUserSelect]',
    standalone: false
})
export class UserSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<UserOption>,
      private statusService: NgrxEagerSelectService<AppState, UserOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      if (this.accountId) {
         staticFilterOverride = [`AccountId = ${this.accountId}`];
      }

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            userOptionActions,
            userOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('userId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
